import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mw-900px w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-row" })
], -1)
const _hoisted_3 = { class: "mw-900px w-100 p-10" }
const _hoisted_4 = { class: "fw-normal py-5 ms-15-lg" }
const _hoisted_5 = { class: "d-flex flex-stack pt-5" }
const _hoisted_6 = { class: "mr-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 me-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" })
], -1)
const _hoisted_8 = {
  type: "submit",
  class: "btn btn-lg btn-primary botonFormSecondary"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-4 ms-1 me-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step0 = _resolveComponent("Step0")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.nombreActividad), 1)
    ]),
    _createElementVNode("form", {
      class: "mx-auto mw-900px w-100 pt-0 pb-10 p-10",
      novalidate: "novalidate",
      id: "kt_create_account_form",
      onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args)))
    }, [
      _createElementVNode("div", null, [
        _createVNode(_component_Step0)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-lg btn-light-primary me-3",
            "data-kt-stepper-action": "previous",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previousStep && _ctx.previousStep(...args)))
          }, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("atrasBtn")), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$t("continuarBtn")) + " ", 1),
            _hoisted_9
          ])
        ])
      ])
    ], 32)
  ]))
}